<template>
  <div>
    <!-- <div class="seth-set bg-primary">
      
      <div class="absolute top-0 py-10 w-full px-6 flex ">
        <div>
          <p
            @click="handleBack"
            class="gap-2 cursor-pointer fsize14 mb-1 text-white flex items-center font-medium"
          >
            <feather-icon
              class="flex"
              icon="ArrowLeftIcon"
              svgClasses="w-6 h-6"
            />
            Go Back
          </p>
          <h2 class="text-white pt-1 text-2xl capitalize font-semibold">
            Landing Page
          </h2>
        </div>
      </div>
    </div>
    <div class="bg-white relative h-full p-8">
      <div class="flex justify-between items-center w-full h-full">
        <div class="relative w-10/12">
          <el-input
            placeholder="Search"
            v-model="input"
            class="w-full"
          ></el-input>
          <div class="absolute top-0 mr-2 mt-2 bg-white cursor-pointer right-0">
            <feather-icon icon="SearchIcon" SvgClasses="w-4 h-4" />
          </div>
        </div>
        <div class="w-2/12 flex justify-end">
          <vs-button
            @click="handleClick('marcom-landing-page-templates')"
            variant="primary"
            class="rounded-lg bg-primary border-0 text-white font-semibold lg:py-3 md:py-3 py-2 px-8 sm-fsize14"
          >
            Add Page
          </vs-button>
        </div>
      </div> -->

    <div class="w-full mt-8">
      <div class="flex justify-between items-center w-full h-full">
        <div class="seth-set bg-primary">
          <el-input
            placeholder="Search"
            v-model="input"
            class="w-full"
          ></el-input>
          <div class="absolute top-0 mr-2 mt-2 bg-white cursor-pointer right-0">
            <feather-icon icon="SearchIcon" SvgClasses="w-4 h-4" />
          </div>
        </div>
      </div>
      <div class="flex justify-end w-full" v-if="copied === true">
        <div class="bg-light-green px-4 py-2 rounded-lg">
          <p class="text-success fsize14 flex gap-2">
            <feather-icon icon="CopyIcon" svgClasses="w-4 h-4" />Copied!
          </p>
        </div>
      </div>
      <el-table
        :data="landingPageDetails"
        border
        style="width: 100%"
        class="table-responsive table-flush mt-6 cust-overflow-x-primary-color fsize12"
        header-row-class-name="thead-light table-th-color"
      >
        <el-table-column prop="city" label="Page Name" min-width="100px">
          <template v-slot="{ row }">
            <P class="text-gray">{{ row.pageName }}</P>
          </template>
        </el-table-column>
        <el-table-column prop="city" label="Link" min-width="200px">
          <template v-slot="{ row }">
            <P
              class="text-primary cursor-pointer"
              @click="openLandingPage(row.fullURL)"
              >{{ row.fullURL }}</P
            >
          </template>
        </el-table-column>
        <!-- <el-table-column
            prop="city"
            label="No. of Recipients"
            min-width="100px"
          >
            <template v-slot="{ row }">
              <P class="text-gray">{{ row.sends }}</P>
            </template>
          </el-table-column>
          <el-table-column prop="city" label="No. of Opens" min-width="90px">
            <template v-slot="{ row }">
              <P class="text-gray">{{ row.clicks }}</P>
            </template>
          </el-table-column>

          <el-table-column min-width="70px" prop="date" label="Created date">
            <template v-slot="{ row }">
              <P class="text-gray">{{
                new Date(row.createdAt).toLocaleDateString()
              }}</P>
            </template>
          </el-table-column> -->

        <el-table-column prop="city" label="Actions" min-width="40px">
          <template v-slot="{ row }">
            <div class="text-center">
              <feather-icon
                icon="CopyIcon"
                svgClasses="w-4 h-4"
                class="cursor-pointer"
                @click="copy(row._id)"
              />
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="w-full flex justify-end mt-6">
        <el-pagination background layout="prev, pager, next" :total="1">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import "@/assets/scss/Index.scss";
import FeatherIcon from "../../../../components/FeatherIcon.vue";
export default {
  components: { FeatherIcon },
  data() {
    return {
      activeName: "first",
      input: "",
      landingData: "",
      editData: "",
      copied: false,
    };
  },
  methods: {
    async copy(id) {
      let index = this.landingData.findIndex((x) => x._id === id);
      this.editData = this.landingData[index];
      console.log(this.editData, "data");
      let copydata = this.editData.fullURL;
      console.log(copydata, "copydata");
      this.copied = true;
      if (this.copied === true) {
        setTimeout(() => {
          this.copied = false;
        }, 2000);
      }

      try {
        let data = await navigator.clipboard.writeText(copydata);
        console.log(data, "copy");
      } catch (err) {
        console.log(err, "error");
      }
    },

    handleClick(name) {
      this.$router.push({ name: name });
    },

    openLandingPage(data) {
      window.open(data, "_blank");
    },
    async getAll() {
      let { data } = await this.$store.dispatch(
        "landingPage/getAllLandingPage"
      );
      this.landingData = data;
    },
  },
  mounted() {
    this.getAll();
    console.log(this.landingPageDetails);
  },
  computed: {
    ...mapState("landingPage", ["landingPageDetails"]),
  },
};
</script>
